import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FxTransfer } from '../../pages';
import { InvoiceController } from '../../controllers';
import { invoiceStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';

const FxTransferContainer = () => {
	const [validatePay, setValidatePay] = useState(false);
	const [chooseCurr, setChooseCurr] = useState('USD');
	const [loading, setLoading] = useState(true);
	const [loading2, setLoading2] = useState(false);
	const [loading3, setLoading3] = useState(false);

	const [searchParams] = useSearchParams();
	const id = searchParams.get('invoiceId');
	const currencyCode = searchParams.get('currencyCode');

	const getpaymentDetails = async () => {
		setLoading(true);
		const { status } = await InvoiceController.fxTransferCheckout(
			id,
			currencyCode
		);
		if (status === constant.Success) {
			setLoading(false);
			setChooseCurr(
				invoiceStore.fxTransferCheckoutData?.foreignAccount?.currencyCode
			);
		}
	};

	const switchPaymentDetails = async currencyCode => {
		setLoading3(true);
		const { status, errorMessage } = await InvoiceController.fxTransferCheckout(
			id,
			currencyCode
		);
		if (status === constant.Success) {
			setLoading3(false);
			return setChooseCurr(
				invoiceStore.fxTransferCheckoutData?.foreignAccount?.currencyCode
			);
		}
		setLoading3(false);
		setChooseCurr(
			invoiceStore.fxTransferCheckoutData?.foreignAccount?.currencyCode
		);
		return MimaToastUtil.error({ message: errorMessage });
	};

	useEffect(() => {
		getpaymentDetails();
	}, []);

	const validatePaymentClick = async () => {
		setLoading2(true);
		const { status, data } = await InvoiceController.invoicePaymentConfirm(id);
		if (status === constant.Success) {
			if (data.msg === 'Payment Confirmed') {
				setLoading2(false);
			}
		}
		const timer = setTimeout(() => {
			setValidatePay(true);
		}, 1000);

		return () => clearTimeout(timer);
	};

	return (
		<FxTransfer
			validatePay={validatePay}
			validatePaymentClick={validatePaymentClick}
			chooseCurr={chooseCurr}
			setChooseCurr={setChooseCurr}
			loading={loading}
			loading2={loading2}
			switchPaymentDetails={switchPaymentDetails}
			loading3={loading3}
		/>
	);
};

export default FxTransferContainer;
